import priceDiscGroupsServiceGen from "./generated/priceDiscGroupsServiceGen";

class priceDiscGroupsService extends priceDiscGroupsServiceGen {
}

export default priceDiscGroupsService;